import {
  FindParecerReferencialPublicoRequestDTO,
  Ordenacoes,
  ParecerReferencialPublicoDTO,
  ParecerReferencialPublicoResponseDTO,
} from '@/views/publico-parecer-referencial/types/index';
import PublicoParecerReferencialService from '@/views/publico-parecer-referencial/service/PublicoParecerReferencialService';
import { defineStore } from 'pinia';
import { SimNao } from '@/types/enum/SimNao';
import SnackbarQueue from '@ungp/sds-snackbar-queue';
import { getAxiosError } from '@/plugins/axios';
import {
  ISubfiltros,
  transformarDadosSubFilter,
  verificarSePossuiItensSelecionadosOuExpandidos,
} from '@/utils/transform';
import { cloneDeep } from '@apollo/client/utilities';

type State = {
  result: ParecerReferencialPublicoResponseDTO | null;
  filter: FindParecerReferencialPublicoRequestDTO;
  showFilter: boolean;
  pareceresSelecionados: ParecerReferencialPublicoDTO[];
  ordenacaoSelecionada: { text?: string; label?: string; value: string } | null;
};

export const getInitialFilter =
  (): FindParecerReferencialPublicoRequestDTO => ({
    nuProcessoOficial: null,
    dePesquisaTermos: null,
    nuAnoProcessoOficial: null,
    nuParecer: null,
    nuAnoParecer: null,
    dtParecerInicio: null,
    dtParecerFim: null,
    dtValidadeInicio: null,
    dtValidadeFim: null,
    flEmenta: SimNao.FL_SIM,
    flParecer: SimNao.FL_SIM,
    anosValidade: [],
    anosParecer: [],
    numPag: 0,
    ordenacao: Ordenacoes.DATA_DESC,
  });

export const usePublicoParecerReferencialStore = defineStore(
  'PublicoParecerReferencialStore',
  {
    state: (): State => ({
      filter: getInitialFilter(),
      result: null,
      showFilter: false,
      pareceresSelecionados: [],
      ordenacaoSelecionada: null,
    }),
    getters: {
      pagina: (state) => state.filter.numPag + 1,
      ordenacoes: (state) => state.result?.ordenacoes || [],
      isImpressaoHabilitada: (state) => state.pareceresSelecionados.length > 0,
    },
    actions: {
      async consultar(resetPagination = false) {
        if (resetPagination) {
          this.filter.numPag = 0;
        }

        const subFiltrosOld = this.result?.subfiltros
          ? cloneDeep(this.result?.subfiltros)
          : null;

        const subfiltros = this.result?.subfiltros
          ? transformarDadosSubFilter(this.result?.subfiltros as ISubfiltros[])
          : {};

        try {
          const { data } = await PublicoParecerReferencialService.consultar({
            ...this.filter,
            ...subfiltros,
          });

          this.result = data;
          this.ordenacaoSelecionada = data.ordenacoes[0];

          if (subFiltrosOld) {
            this.result.subfiltros =
              verificarSePossuiItensSelecionadosOuExpandidos(
                this.result?.subfiltros,
                subFiltrosOld
              );
          }
        } catch (error) {
          SnackbarQueue.error(getAxiosError(error));
        }
      },
      async downloadSelecionados() {
        for (const parecer of this.pareceresSelecionados) {
          window.open(
            PublicoParecerReferencialService.getUrlDownload(
              parecer.idParecerReferencial
            ),
            '_blank'
          );
        }
      },
      async limpar() {
        this.filter = getInitialFilter();
      },
    },
  }
);
